import { PricingDetails } from "@db-models/pricing-db.model";

export const SALES_PRICING_JSON: PricingDetails[] = [
  {
    chf: {
      monthly: { original_price: 29.90 },
      // 12 * 29.90 * 0.9 = 322.8 → 322.8 / 12 = 26.9
      yearly: { original_price: 26.9, saving_amount: 35.20, saving_percent: 10 },
      // 12 * 2 * 29.90 * 0.85 = 609.6 → 609.6 / 24 = 25.4
      year_2: { original_price: 25.4, saving_amount: 107.40, saving_percent: 15 },
      // 12 * 3 * 29.90 * 0.8 = 856.8 → 856.8 / 36 = 23.8
      year_3: { original_price: 23.8, saving_amount: 215.40, saving_percent: 20 }
    },
    eur: {
      monthly: { original_price: 29.90 },
      yearly: { original_price: 26.9, saving_amount: 35.20, saving_percent: 10 },
      year_2: { original_price: 25.4, saving_amount: 107.40, saving_percent: 15 },
      year_3: { original_price: 23.8, saving_amount: 215.40, saving_percent: 20 }
    },
    gbp: {
      monthly: { original_price: 26 },
      // 12 * 26 * 0.9 = 280.8 → 280.8 / 12 = 23.4
      yearly: { original_price: 23.4, saving_amount: 31.20, saving_percent: 10 },
      // 12 * 2 * 26 * 0.85 = 530.4 → 530.4 / 24 = 22.1
      year_2: { original_price: 22.1, saving_amount: 49.60, saving_percent: 15 },
      // 12 * 3 * 26 * 0.8 = 748.8 → 748.8 / 36 = 20.8
      year_3: { original_price: 20.8, saving_amount: 187.20, saving_percent: 20 }
    },
    usd: {
      monthly: { original_price: 35 },
      // 12 * 35 * 0.9 = 378 → 378 / 12 = 31.5
      yearly: { original_price: 31.5, saving_amount: 42.00, saving_percent: 10 },
      // 12 * 2 * 35 * 0.85 = 714 → 714 / 24 = 29.75
      year_2: { original_price: 29.75, saving_amount: 126.00, saving_percent: 15 },
      // 12 * 3 * 35 * 0.8 = 1008 → 1008 / 36 = 28
      year_3: { original_price: 28, saving_amount: 84.00, saving_percent: 20 }
    },
    description: "Calenso basic",
    id: 103,
    included_bookings: 0,
    name: "basic",
    min_workers: 1,
    min_store: 1,
    min_group_appointment: 1,
    min_conference: 0,
    subscription_title: 'Basic',
    subscription_subtitle: {
      en_US: "The perfect starting point for GDPR-compalint online appointment scheduling.",
      de_CH: "Der perfekte Ausgangspunkt für die DSGVO-konforme Online-Terminplanung."
    },
    feature_list_title: {
      en_US: "Basis for scheduling your team",
      de_CH: "Basis für die Terminvereinbarung"
    },
    feature_list: {
      sales: [
        {
          en_US: "1 user",
          de_CH: "1 Benutzer"
        },
        {
          en_US: "1 store",
          de_CH: "1 Filiale"
        },
        {
          en_US: "GDPR, nDSG & EU-DPF compliant",
          de_CH: "DSGVO, nDSG & EU-DPF konform"
        },
        {
          en_US: "ISO 27001 certified company and servers",
          de_CH: "ISO 27001 zertifizierte Firma und Server"
        },
        {
          en_US: "<a href=\"https://www.myrasecurity.com/en/saasp/application-security/hyperscale-waf/\" target='_blank'>BSI-certified firewall</a>",
          de_CH: "<a href=\"https://www.myrasecurity.com/en/saasp/application-security/hyperscale-waf/\" target='_blank'>BSI-zertifizierte Firewall</a>"
        },
        {
          en_US: "Individual appointment scheduling",
          de_CH: "Einzelterminbuchung"
        },
        {
          en_US: "Round Robin",
          de_CH: "Round Robin"
        },
        {
          en_US: "Individual forms",
          de_CH: "Individuelle Formulare"
        },
        {
          en_US: "Website integration",
          de_CH: "Webseiten Integration"
        },
        {
          en_US: "Appointment reminders",
          de_CH: "Terminerinnerungen"
        },
        {
          en_US: "Google Calendar",
          de_CH: "Google Kalender"
        },
        {
          en_US: "Online Payment (Stripe, Coupons)",
          de_CH: "Online Payment (Stripe, Rabattverwaltung)"
        },
        {
          en_US: "Video consultation via Zoom",
          de_CH: "Video Beratung via Zoom"
        },
        {
          en_US: "Self-service support",
          de_CH: "Self-Service-Support"
        },
        {
          en_US: "No MS-Exchange, Office365, iCloud or CalDAV calandars",
          de_CH: "Keine MS-Exchange, Office365, iCloud oder CalDAV-Kalender",
          include: false
        },
        {
          en_US: "No PayPal, SaferPay, Bexio invoices",
          de_CH: "Kein PayPal, SaferPay, Bexio-Rechnungen",
          include: false
        },
        {
          en_US: "No GoTo-Meeting, Webex, Unblu",
          de_CH: "Kein GoTo-Meeting, Webex, Unblu",
          include: false
        },
        {
          en_US: "No SMS Notifications",
          de_CH: "Keine SMS-Benachrichtigungen",
          include: false
        },
      ]
    },
  },
  {
    chf: {
      monthly: { original_price: 89.90 },
      // 12 * 89.90 * 0.9 = 970.8 → 970.8 / 12 = 80.9
      yearly: { original_price: 80.9, saving_amount: 107.80, saving_percent: 10 },
      // 12 * 2 * 89.90 * 0.85 = 1833.96 → 1834 / 24 = 76.41
      year_2: { original_price: 76.41, saving_amount: 323.55, saving_percent: 15 },
      // 12 * 3 * 89.90 * 0.8 = 2589.12 → 2589.12 / 36 = 71.92
      year_3: { original_price: 71.92, saving_amount: 647.40, saving_percent: 20 }
    },
    eur: {
      monthly: { original_price: 89.90 },
      yearly: { original_price: 80.9, saving_amount: 107.80, saving_percent: 10 },
      year_2: { original_price: 76.41, saving_amount: 323.55, saving_percent: 15 },
      year_3: { original_price: 71.92, saving_amount: 647.40, saving_percent: 20 }
    },
    gbp: {
      monthly: { original_price: 79 },
      // 12 * 79 * 0.9 = 852.0 → 852 / 12 = 71.0
      yearly: { original_price: 71.0, saving_amount: 95.00, saving_percent: 10 },
      // 12 * 2 * 79 * 0.85 = 1609.2 → 1609.2 / 24 = 67.05
      year_2: { original_price: 67.05, saving_amount: 50.95, saving_percent: 15 },
      // 12 * 3 * 79 * 0.8 = 2262.4 → 2262.4 / 36 = 62.85
      year_3: { original_price: 62.85, saving_amount: 69.15, saving_percent: 20 }
    },
    usd: {
      monthly: { original_price: 105 },
      // 12 * 105 * 0.9 = 1134 → 1134 / 12 = 94.5
      yearly: { original_price: 94.5, saving_amount: 126.00, saving_percent: 10 },
      // 12 * 2 * 105 * 0.85 = 2142 → 2142 / 24 = 89.25
      year_2: { original_price: 89.25, saving_amount: 315.00, saving_percent: 15 },
      // 12 * 3 * 105 * 0.8 = 3024 → 3024 / 36 = 84
      year_3: { original_price: 84, saving_amount: 336.00, saving_percent: 20 }
    },
    description: "Calenso professional",
    id: 102,
    included_bookings: 0,
    name: "professional",
    min_workers: 3,
    min_store: 3,
    min_group_appointment: 10,
    min_conference: 0,
    subscription_title: 'Professional',
    subscription_subtitle: {
      en_US: "Ideal for businesses seeking personalized branding and dependable data protection.",
      de_CH: "Ideal für Unternehmen, die personalisierte Markenbildung und zuverlässigen Datenschutz suchen."
    },
    feature_list_title: {
      en_US: "Everything in Basic, plus",
      de_CH: "Alles in Basic, plus"
    },
    feature_list: {
      sales: [
        {
          en_US: "3 users",
          de_CH: "3 Benutzer"
        },
        {
          en_US: "3 stores",
          de_CH: "3 Filialen"
        },
        {
          en_US: "10 group appointments",
          de_CH: "10 Gruppentermine"
        },
        {
          en_US: "Custom logo",
          de_CH: "Benutzerdefiniertes Logo"
        },
        {
          en_US: "Video Meetings",
          de_CH: "Video Beratung"
        },
        {
          en_US: "Branches & team structure",
          de_CH: "Filialen & Team-Struktur"
        },
        {
          en_US: "Analyzes and statistics",
          de_CH: "Analysen und Statistiken"
        },
        {
          en_US: "Google Kalender, Office365, iCloud & CalDAV calendar",
          de_CH: "Google Kalender, Office365, iCloud & CalDAV-Kalender"
        },
        {
          en_US: "Online Payment (incl. Bexio invoices)",
          de_CH: "Online Payment (inkl. Bexio Rechnungen)"
        },
        {
          en_US: "Appointment confirmation & reminder via email and SMS",
          de_CH: "Terminbestätigung & -erinnerung per E-Mail & SMS"
        },
        {
          en_US: "Video consultation via GoTo Meeting, Cisco Webex",
          de_CH: "Video Beratung via GoTo-Meeting, Cisco Webex"
        },
        {
          en_US: "Standard Support via email (approx. 72h)",
          de_CH: "Standard Support via E-Mail (ca. 72 Std.)"
        },
        {
          en_US: "No Microsoft Exchange calendar",
          de_CH: "Keinen Microsoft Exchange",
          include: false
        },
      ]
    },
  },
  {
    chf: {
      monthly: { original_price: 249.90 },
      // 12 * 249.90 * 0.9 = 2698.92 → 2699 / 12 = 224.9
      yearly: { original_price: 224.9, saving_amount: 299.80, saving_percent: 10 },
      // 12 * 2 * 249.90 * 0.85 = 5097.96 → 5098 / 24 = 212.4
      year_2: { original_price: 212.4, saving_amount: 899.60, saving_percent: 15 },
      // 12 * 3 * 249.90 * 0.8 = 7197.12 → 7197 / 36 = 199.9
      year_3: { original_price: 199.9, saving_amount: 1799.40, saving_percent: 20 }
    },
    eur: {
      monthly: { original_price: 249.90 },
      yearly: { original_price: 224.9, saving_amount: 299.80, saving_percent: 10 },
      year_2: { original_price: 212.4, saving_amount: 899.60, saving_percent: 15 },
      year_3: { original_price: 199.9, saving_amount: 1799.40, saving_percent: 20 }
    },
    gbp: {
      monthly: { original_price: 219 },
      // 12 * 219 * 0.9 = 2365.2 → 2365 / 12 = 197.1
      yearly: { original_price: 197.1, saving_amount: 263.00, saving_percent: 10 },
      // 12 * 2 * 219 * 0.85 = 4467.6 → 4468 / 24 = 186.1
      year_2: { original_price: 186.1, saving_amount: 788.00, saving_percent: 15 },
      // 12 * 3 * 219 * 0.8 = 6307.2 → 6307 / 36 = 175.2
      year_3: { original_price: 175.2, saving_amount: 1577.00, saving_percent: 20 }
    },
    usd: {
      monthly: { original_price: 295 },
      // 12 * 295 * 0.9 = 3186 → 3186 / 12 = 265.5
      yearly: { original_price: 265.5, saving_amount: 354.00, saving_percent: 10 },
      // 12 * 2 * 295 * 0.85 = 6018 → 6018 / 24 = 250.75
      year_2: { original_price: 250.75, saving_amount: 1062.00, saving_percent: 15 },
      // 12 * 3 * 295 * 0.8 = 8496 → 8496 / 36 = 236.0
      year_3: { original_price: 236.0, saving_amount: 2124.00, saving_percent: 20 }
    },
    description: "Calenso Business",
    id: 104,
    included_bookings: 0,
    name: "business",
    min_workers: 5,
    min_store: 5,
    min_group_appointment: 15,
    min_conference: 5,
    subscription_title: 'Business',
    subscription_subtitle: {
      en_US: "Tailored for companies aiming to digitize their appointment processes with a focus on reliable data protection and unique branding.",
      de_CH: "Zugeschnitten für Unternehmen, die ihre Terminprozesse digitalisieren möchten, mit Schwerpunkt auf zuverlässigem Datenschutz und einzigartigem Branding."
    },
    feature_list_title: {
      en_US: "Everything in Professional, plus",
      de_CH: "Alles in Professional, plus"
    },
    feature_list: {
      sales: [
        {
          en_US: "5 users",
          de_CH: "5 Benutzer"
        },
        {
          en_US: "5 stores",
          de_CH: "5 Filialen"
        },
        {
          en_US: "5 conference appointments",
          de_CH: "5 Konferenztermine"
        },
        {
          en_US: "15 group appointments",
          de_CH: "15 Gruppentermine"
        },
        {
          en_US: "Multilingualism",
          de_CH: "Mehrsprachigkeit"
        },
        {
          en_US: "Individual design & branding",
          de_CH: "Individuelles Design & Branding"
        },
        {
          en_US: "Qualification questions (routing)",
          de_CH: "Qualifizierungsfragen (Routing)"
        },
        {
          en_US: "Workflows",
          de_CH: "Workflows"
        },
        {
          en_US: "Encrypted customer and appointment data",
          de_CH: "Verschlüsselte Kunden- und Termindaten"
        },
        {
          en_US: "Online Payment incl. SaferPay (Klarna, TWINT, PostFinance)",
          de_CH: "Online Payment inkl. SaferPay (Klarna, TWINT, PostFinance)"
        },
        {
          en_US: 'Mail sending from your own SMTP mail server',
          de_CH: 'Mailversand von eigenem SMTP-Mailserver'
        },
        {
          en_US: "Video consultation via Microsoft Teams",
          de_CH: "Video Beratung via Microsoft Teams"
        },
        {
          en_US: "Priority email support with callback service (approx. 24h)",
          de_CH: "Priorisierter Support via E-Mail mit Rückrufservice (ca. 24 Std.)"
        },
        {
          en_US: "No Microsoft Exchange Impersonation",
          de_CH: "Keine Microsoft Exchange Impersonation",
          include: false
        },
        {
          en_US: "No REST api access",
          de_CH: "Kein REST-API Zugriff",
          include: false
        },
        {
          en_US: "No audit logs",
          de_CH: "Keine Audit-Logs",
          include: false
        },
        {
          en_US: "No appointment status feature",
          de_CH: "Keine Termin-Status Funktion",
          include: false
        },
        {
          en_US: "No booking limit feature",
          de_CH: "Keine Buchungslimit Funktion",
          include: false
        },
        {
          en_US: "No postcode routing",
          de_CH: "Kein Postleitzahl-Routing",
          include: false
        }
      ]
    }
  },
  {
    chf: {
      monthly: { original_price: 599.90 },
      // 12 * 599.90 = 7199 → 7199 / 12 = 599.9
      yearly: { original_price: 599.9, saving_amount: 0, saving_percent: 0 },
      // 12 * 2 * 599.90 * 0.9 = 12958 → 12958 / 24 = 539.9
      year_2: { original_price: 539.9, saving_amount: 1440, saving_percent: 10 },
      // 12 * 3 * 599.90 * 0.85 = 18356 → 18356 / 36 = 509.9
      year_3: { original_price: 509.9, saving_amount: 3240, saving_percent: 15 }
    },
    eur: {
      monthly: { original_price: 599.90 },
      yearly: { original_price: 599.9, saving_amount: 0, saving_percent: 0 },
      year_2: { original_price: 539.9, saving_amount: 1440, saving_percent: 10 },
      year_3: { original_price: 509.9, saving_amount: 3240, saving_percent: 15 }
    },
    gbp: {
      monthly: { original_price: 549 },
      // 12 * 549  = 5929.2 → 6,588 / 12 = 549
      yearly: { original_price: 549, saving_amount: 0, saving_percent: 0 },
      // 12 * 2 * 549 * 0.9 = 11,858.4 → 11,858 / 24 = 494.1
      year_2: { original_price: 494.1, saving_amount: 1314, saving_percent: 10 },
      // 12 * 3 * 549 * 0.85 = 16799.4 → 16799 / 36 = 466.65
      year_3: { original_price: 466.65, saving_amount: 2964, saving_percent: 15 }
    },
    usd: {
      monthly: { original_price: 699 },
      // 12 * 699  = 7558.8 → 8,388 / 12 = 699
      yearly: { original_price: 699, saving_amount: 0, saving_percent: 0 },
      // 12 * 2 * 699 * 0.9 =  15,098.4 → 15,098 / 24 = 629.1
      year_2: { original_price: 629.1, saving_amount: 1674, saving_percent: 10 },
      // 12 * 3 * 699 * 0.85 = 21,389.4 → 21,389.4 / 36 = 594.15
      year_3: { original_price: 594.15, saving_amount: 3747, saving_percent: 15 }
    },
    description: "Calenso Enterprise Lite",
    id: 106,
    included_bookings: 0,
    name: "enterpriselite",
    min_workers: 10,
    min_store: 5,
    min_group_appointment: 20,
    min_conference: 10,
    subscription_title: 'Enterprise Lite',
    subscription_subtitle: {
      en_US: "Suited for companies requiring secure, scalable, and customizable software solutions for digitizing their appointment processes.",
      de_CH: "Geeignet für Unternehmen, die sichere, skalierbare und anpassbare Softwarelösungen für die Digitalisierung ihrer Terminprozesse benötigen."
    },
    feature_list_title: {
      en_US: "Everything in Business, plus",
      de_CH: "Alles in Business, plus"
    },
    feature_list: {
      sales: [
        {
          en_US: "10 users",
          de_CH: "10 Benutzer"
        },
        {
          en_US: "5 stores",
          de_CH: "5 Filialen"
        },
        {
          en_US: "10 conference appointments",
          de_CH: "10 Konferenztermine"
        },
        {
          en_US: "20 group appointments",
          de_CH: "20 Gruppentermine"
        },
        {
          en_US: "Audit Logs (5 days retention)",
          de_CH: "Audit Logs (5 Tage Aufbewahrungszeit)"
        },
        {
          en_US: "No Single-Sign-On (SSO): Microsoft Azure AD, Active Directory / LDAP",
          de_CH: "Kein Single-Sign-On (SSO): Microsoft Azure AD, Active Directory / LDAP",
          include: false
        },
        {
          en_US: "No custom roles",
          de_CH: "Keine firmenspezifische Benutzer-Rollen",
          include: false
        },
        {
          en_US: "No InxMail integration",
          de_CH: "Keine InxMail Integration",
          include: false
        },
        {
          en_US: "No dedicated test system",
          de_CH: "Kein Dediziertes Test-System",
          include: false
        },
        {
          en_US: "No personal account manager",
          de_CH: "Kein persönlicher Account-Manager",
          include: false
        }
      ]
    },
  },
  {
    chf: {
      monthly: { original_price: 1599.90 },
      // 12 * 1599.90  = 19,198.8 → / 12 = 1599.90
      yearly: { original_price: 1599.90, saving_amount: 0, saving_percent: 0 },
      // 12 * 2 * 1599.90 * 0.9 = 34,538.4 → 34,538.4 / 24 = 1,439.1
      year_2: { original_price: 1439.1, saving_amount: 3840, saving_percent: 10 },
      // 12 * 3 * 1599.90 * 0.85 = 48,956.94 → 48,957 / 36 = 1,359.92
      year_3: { original_price: 1359.92, saving_amount: 8639, saving_percent: 15 }
    },
    eur: {
      monthly: { original_price: 1599.90 },
      yearly: { original_price: 1599.90, saving_amount: 0, saving_percent: 0 },
      year_2: { original_price: 1439.1, saving_amount: 3840, saving_percent: 10 },
      year_3: { original_price: 1359.92, saving_amount: 8639, saving_percent: 15 }
    },
    gbp: {
      monthly: { original_price: 1499 },
      // 12 * 1499  = 17,988 → 17,988 / 12 = 1,499
      yearly: { original_price: 1499, saving_amount: 0, saving_percent: 0 },
      // 12 * 2 * 1499 * 0.9 = 32,378.4 → 32,378.4 / 24 = 1,349.1
      year_2: { original_price: 1349.1, saving_amount: 3596, saving_percent: 10 },
      // 12 * 3 * 1499 * 0.85 = 45,869.4 → 45,869.4 / 36 = 1,274.1
      year_3: { original_price: 1274.1, saving_amount: 8094, saving_percent: 15 }
    },
    usd: {
      monthly: { original_price: 1799 },
      // 12 * 1799  = 21,588 → 21,588 / 12 = 1,799
      yearly: { original_price: 1799, saving_amount: 0, saving_percent: 0 },
      // 12 * 2 * 1799 * 0.9 = 38,858.4 → 38,858.4 / 24 = 1,619.1
      year_2: { original_price: 1619.1, saving_amount: 4320, saving_percent: 10 },
      // 12 * 3 * 1799 * 0.85 = 55,049.4 → 55,049.4 / 36 = 1,529.15
      year_3: { original_price: 1529.15, saving_amount: 9726, saving_percent: 15 }
    },
    description: "Calenso Enterprise",
    id: 105,
    included_bookings: 0,
    name: "enterprise",
    min_workers: 25,
    min_store: 10,
    min_group_appointment: 30,
    min_conference: 10,
    subscription_title: 'Enterprise',
    subscription_subtitle: {
      en_US: "Suited for companies requiring secure, scalable, and customizable software solutions for digitizing their appointment processes.",
      de_CH: "Geeignet für Unternehmen, die sichere, skalierbare und anpassbare Softwarelösungen für die Digitalisierung ihrer Terminprozesse benötigen."
    },
    feature_list_title: {
      en_US: "Everything in Business, plus",
      de_CH: "Alles in Business, plus"
    },
    feature_list: {
      sales: [
        {
          en_US: "25 users",
          de_CH: "25 Benutzer"
        },
        {
          en_US: "10 stores",
          de_CH: "10 Filialen"
        },
        {
          en_US: "10 conference appointments",
          de_CH: "10 Konferenztermine"
        },
        {
          en_US: "30 group appointments",
          de_CH: "30 Gruppentermine"
        },
        {
          en_US: "Corporate design & customization",
          de_CH: "Corporate Design & Branding"
        },
        {
          en_US: "Personal account manager (prioritized support according to SLA)",
          de_CH: "Persönlicher Account-Manager (priorisierter Support nach SLA)"
        },
        {
          en_US: "Company-specific user roles Advanced security settings",
          de_CH: "Erweiterte Sicherheitseinstellungen"
        },
        {
          en_US: "Audit Logs (30 days retention)",
          de_CH: "Audit Logs (30 Tage Aufbewahrungszeit)"
        },
        {
          en_US: "Custom roles and permissions",
          de_CH: "Benutzerdefinierte Rollen und Berechtigungen"
        },
        {
          en_US: "Single-Sign-On (SSO): Microsoft Azure AD, Active Directory / LDAP",
          de_CH: "Single-Sign-On (SSO): Microsoft Azure AD, Active Directory / LDAP"
        },
        {
          en_US: "CRM and ERP integrations",
          de_CH: "CRM- und ERP Integrationen"
        },
        {
          en_US: "Dynamic Availabilities (via Office365 or Microsoft Exchange Calendar)",
          de_CH: "Dynamische Verfügbarkeiten (via Office365 oder Microsoft Exchange Kalender)"
        },
        {
          en_US: "Video consultation via Unblu",
          de_CH: "Video Beratung via Unblu"
        },
        {
          en_US: "Automatic employee onboarding and offboarding with Microsoft Entra ID",
          de_CH: "Automatisches Mitarbeiter On- & Offboarding mit Microsoft Entra ID"
        },
      ]
    },
  }
]

export const MAX_LIMITE = 100000;
export const MIN_LIMITE = 1;
export const MIN_CONFERENCE_LIMITE = 0;

export const EXTRA_USER_COST = 5;
export const EXTRA_GROUP_APPOINTMENT_COST = 10;
export const EXTRA_STORE_COST = 10;
export const EXTRA_CONFERENCE_COST = 10;

export const SALES_TOKEN = '82e80dc8-9318-4be5-9be1-e8ef79859fca';
